import React, { useEffect, useState } from "react";
import { Button, Form } from "antd";
import CardDiv from "modules/common/card-div/CardDiv";
import SelectDataToDisplay from "assets/svgs/no_data_icon/SelectDataToDisplay";
import { Offcanvas } from "react-bootstrap";
import QuestionsFilter from "./QuestionsFilter";
import { useQaQuestions } from "./store";
import QA_Table from "./QA_Table";

const QA_questions = () => {
  const {
    fetchQuestionsAfterFilterApply,
    questionsFilterData,
    questionsFilterDataLoading,
    fetchQuestionsFilter,
    fetchAddNewQuestion,
  } = useQaQuestions();

  const [visible, setVisible] = useState(false);
  const [visibleQuestions, setVisibleQuestions] = useState(false);
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [queryParam, setQueryParam] = useState({
    monthCount: [],
    engagementType: [],
  });
  const [savedFormValues, setSavedFormValues] = useState({});
  const [isReordering, setIsReordering] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [showSubmitCancel, setShowSubmitCancel] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (triggerFetch) {
      const fetchData = async () => {
        await fetchQuestionsAfterFilterApply(queryParam);
      };
      fetchData();
      setTriggerFetch(false);
    }
  }, [triggerFetch]);

  useEffect(() => {
    fetchQuestionsFilter();
  }, []);

  const handleFinishApplyFilter = (values, form) => {
    form.setFields([
      { name: "monthCount", errors: [] },
      { name: "engagementType", errors: [] },
    ]);
    if (
      (!values.engagementType || values.engagementType.length === 0) &&
      (!values.monthCount || values.monthCount.length === 0)
    ) {
      form.setFields([
        {
          name: "monthCount",
          errors: ["Please select month count or engagement type"],
        },
        {
          name: "engagementType",
          errors: ["Please select month count or engagement type"],
        },
      ]);
      return;
    }
    const queryParamUpdated = {
      monthCount: values.monthCount,
      engagementType: values.engagementType,
    };
    setSavedFormValues(values);
    setQueryParam(queryParamUpdated);
    setTriggerFetch(true);
    setVisibleQuestions(true);
    setVisible(!visible);
  };

  const handleClear = () => {
    form.resetFields();
    const initialQueryParam={
        monthCount: [],
        engagementType: [],
      }
    setQueryParam(initialQueryParam);
    setSavedFormValues({});
    setVisibleQuestions(false);
    setVisible(!visible);
  };

  const toggleReorder = () => {
    setIsReordering((prev) => {
      const newState = !prev;
      setShowSubmitCancel(newState);
      return newState;
    });
  };

  return (
    <>
      <CardDiv
        title={
          <>
            <div className="d-flex align-items-center justify-content-between ">
              <h3 className="fw-bold">QA Questions</h3>
              <div className="d-flex gap-2">
                {visibleQuestions && (
                  <Button
                    onClick={toggleReorder}
                    disabled={isReordering || isAdding}
                  >
                    Reorder
                  </Button>
                )}
                {visibleQuestions && (
                  <Button onClick={() => setIsAdding(true)} disabled={isReordering}>Add</Button>
                )}
                <Button
                  type="primary"
                  onClick={() => setVisible(true)}
                  disabled={isReordering || isAdding}
                >
                  Filter
                </Button>
              </div>
              <Offcanvas
                show={visible}
                onHide={() => setVisible(false)}
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Filter for Questions</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <QuestionsFilter
                    savedFormValues={savedFormValues}
                    handleClear={handleClear}
                    handleFinish={handleFinishApplyFilter}
                    filterData={questionsFilterData}
                    filterDataLoading={questionsFilterDataLoading}
                  />
                </Offcanvas.Body>
              </Offcanvas>
            </div>
          </>
        }
        component={
          <>
            <div
              className="d-flex flex-column gap-2 align-items-center justify-content-center mb-5 min-h-"
              style={{ minHeight: "80vh" }}
            >
              {visibleQuestions === false ? (
                <div className="container-fluid d-flex justify-content-center align-items-center ">
                  <div className=" text-center">
                    <SelectDataToDisplay />
                    <h5 className=" p-2 text-bg-light">
                      Apply Filter To Display Questions
                    </h5>
                  </div>
                </div>
              ) : (
                <>
                  <QA_Table
                    savedFormValues={savedFormValues}
                    isReordering={isReordering}
                    setIsReordering={setIsReordering}
                    showSubmitCancel={showSubmitCancel}
                    setShowSubmitCancel={setShowSubmitCancel}
                    setTriggerFetch={setTriggerFetch}
                    isAdding={isAdding}
                    setIsAdding={setIsAdding}
                  />
                </>
              )}
            </div>
          </>
        }
      />
    </>
  );
};

export default QA_questions;
